import { useEffect, useState } from "react";

import "../../styles/base.css";
import "../../styles/board.css";
import "../../styles/common.css?ver=1";
import "../../styles/is.css?ver=2";
import Busi_si from "./Busi_si";
import Busi_security from "./Busi_security";
import Busi_consulting from "./Busi_consulting";
import { useNavigate } from "react-router-dom";

interface AreaProps {
  tabIndex: number;
}

const Area: React.FC<AreaProps> = ({ tabIndex }) => {
  const navigate = useNavigate();
  const [currentTab, setCurrentTab] = useState(tabIndex);

  const menuArr = [
    { name: "농림정보화", content: <Busi_si />, path: "busi_si" },
    { name: "정보보호", content: <Busi_security />, path: "busi_security" },
    { name: "컨설팅", content: <Busi_consulting />, path: "busi_consulting" },
  ];

  const selectMenuHandler = ({ index, path }: any) => {
    setCurrentTab(index);
    navigate(`/${path}`);
  };

  useEffect(() => {
    setCurrentTab(tabIndex);
    window.scrollTo(0, 0);
  }, [tabIndex]);

  return (
    <div>
      <div className="sub-visual subv-2">
        <h1>
          <span>BUSINESS AREA</span>
          <p>제닉스가 미래를 향해 도약합니다.</p>
        </h1>
        <div className="sub-depth-1">
          <ul className="tab-list" style={{ cursor: "pointer" }}>
            {" "}
            {menuArr.map((tab, index) => (
              <li key={index} className={currentTab === index ? "active" : ""} onClick={() => selectMenuHandler({ index, path: tab.path })}>
                {tab.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div>{menuArr[currentTab].content}</div>
    </div>
  );
};

export default Area;
